<template>
  <q-card flat bordered>
    <q-card-section
      class="q-pa-sm bg-primary row justify-between items-center text-white"
    >
      <div class="text-subtitle1 text-bold">
        <q-icon
          name="attach_money"
          style="font-size: 25px; padding-right: 0.1rem"
        />
        Pricing
      </div>
      <div class="row items-center q-gutter-x-sm">
        <slot name="header"></slot>
        <q-btn
          v-if="!readonly && action === 'view' && !inBatchUpdating"
          icon="edit"
          color="secondary"
          dense
          flat
          size="sm"
          @click="inBatchUpdating = true"
        />
        <q-btn
          v-if="!readonly && action === 'view' && inBatchUpdating"
          icon="check"
          color="primary"
          dense
          flat
          size="sm"
          @click="handleBatchUpdate"
        />
        <q-btn
          v-if="!readonly && action === 'view' && inBatchUpdating"
          icon="cancel"
          color="red"
          dense
          flat
          size="sm"
          @click="inBatchUpdating = false"
        />
        <q-btn
          v-if="!readonly"
          label="Run Auto Quoter"
          color="secondary"
          size="sm"
          :loading="runningTaq"
          @click="$emit('run-taq')"
        />
      </div>
    </q-card-section>
    <q-separator />
    <q-card-section>
      <div class="row">
        <div class="col">
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.deposit"
              prefix="$"
              min="0"
              type="number"
              text="Deposit *"
              textClasses="text-weight-bold"
              name="deposit"
              @input="
                delayTouch(validation.deposit, $options.touchMap);
                handleChange($event);
              "
              :error="validation.deposit.$error"
              inputClasses="text-bold text-large"
            />
          </div>
          <div>
            <app-editable-input
              class="input-highlighted-1"
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="carrierPay"
              prefix="$"
              type="number"
              min="0"
              text="Carrier Pay *"
              textClasses="text-weight-bold text-brand3"
              inputClasses="text-brand3 text-bold text-large"
              name="carrierPay"
              @input="handleChange($event);"
            />
          </div>
          <div style="min-height:40px">
            <app-editable-input
              v-if="fullPayEnabled"
              :loadingData="loadingData"
              :readonly="true"
              :data="fullPay"
              prefix="$"
              min="0"
              type="number"
              text="Full Pay"
              name="fullPay"
            />
          </div>
          <div>
            <app-editable-input
              class="input-highlighted-2"
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="totalPrice"
              prefix="$"
              min="0"
              type="number"
              text="Total Price"
              textClasses="text-weight-bold text-secondary"
              inputClasses="text-secondary  text-bold text-large"
              name="totalPrice"
              @input="handleTotalPriceChange($event.model)"
              :error="validation.totalPrice.$error"
            />
          </div>
          <div>
            <app-editable-input
              v-if="fullPayEnabled"
              :loadingData="loadingData"
              :readonly="true"
              :data="Math.floor(totalPrice * 1.05)"
              prefix="$"
              min="0"
              type="number"
              text="Total Price +"
              name="totalPrice+"
            />
          </div>
        </div>
        <div class="col-1">
          <div class="flex items-center justify-center full-height">
            <q-icon :name="isLinked ? 'link' : 'link_off'" />
          </div>
        </div>
        <div class="col">
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.basePrice"
              prefix="$"
              type="number"
              min="0"
              text="Base Price *"
              name="basePrice"
              @input="
                delayTouch(validation.basePrice, $options.touchMap);
                handleChange($event);
              "
              :error="validation.basePrice.$error"
            />
          </div>
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.inopFee"
              prefix="$"
              type="number"
              text="Inop Fee"
              name="inopFee"
              @input="handleChange($event)"
            />
          </div>
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.sizeFee"
              prefix="$"
              type="number"
              text="Size Fee"
              name="sizeFee"
              @input="handleChange($event)"
            />
          </div>
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.sizeFeeByDistance"
              prefix="$"
              type="number"
              text="Size Fee By Distance"
              name="sizeFeeByDistance"
              @input="handleChange($event)"
            />
          </div>
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.depositFeeByDistance"
              prefix="$"
              type="number"
              text="Deposit Fee By Distance"
              name="depositFeeByDistance"
              @input="handleChange($event)"
            />
          </div>
          <div>
            <app-editable-input
              :loadingData="loadingData"
              :readonly="isReadOnlyField"
              :data="value.enclosedFee"
              prefix="$"
              type="number"
              text="Enclosed Fee"
              name="enclosedFee"
              @input="handleChange($event)"
            />
          </div>
        </div>
      </div>

      <slot name="append"></slot>
    </q-card-section>
  </q-card>
</template>
<script>
import AppEditableInput from '@client/components/form/editable-input';

export default {
  name: 'AppTransportPricingCard',
  components: {
    AppEditableInput
  },
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    value: Object,
    fullPayEnabled: Boolean,
    runningTaq: {
      type: Boolean,
      default: false
    },
    context: {
      type: String,
      default: 'quote'
    },
    readonly: Boolean,
    action: {
      type: String,
      default: 'create'
    },
    validation: Object
  },
  data() {
    return {
      inBatchUpdating: false,
      showModifiers: false,
      isLinked: false
    };
  },
  computed: {
    isReadOnlyField() {
      if (this.inBatchUpdating) return false;
      return this.readonly || this.action === 'view';
    },
    carrierPay() {
      return this.getCarrierPay();
    },
    totalPrice() {
      this.calculateLinked(this.value);
      return this.calcTotalPrice(this.value);
    },
    fullPay() {
      if (!this.fullPayEnabled) return 0;
      return Math.floor(
        (this.value.totalPrice * 0.05)
      );
    }
  },
  watch: {
    runningTaq: function (newVal, oldVal) {
      if (oldVal && !newVal) {
        this.setPricesByRunAutoQuote(this.value);
      }
    },
    loadingData: function (newVal, oldVal) {
      if (oldVal && !newVal) {
        this.validation.totalPrice.$model = this.totalPrice;
      }
    },
    fullPayEnabled: function (newVal) {
      this.handleFullPay(newVal);
    }
  },
  methods: {
    calculateLinked(value) {
      const carrierPayByFee = this.calculateCarrierPayByFee(value);
      this.isLinked = value.carrierPay === carrierPayByFee;
    },
    getCarrierPay() {
      if (this.value.carrierPay) return this.value.carrierPay;

      const carrierPay = this.calculateCarrierPayByFee();
      this.value.carrierPay = carrierPay;

      this.calculateLinked(this.value);
      return this.calculateCarrierPayByFee();
    },
    calculateCarrierPayByFee(value) {
      const pricing = value ? { ...value } : { ...this.value };
      return (Number.isNaN(pricing.basePrice) ? 0 : pricing.basePrice) +
         (Number.isNaN(pricing.sizeFee) ? 0 : pricing.sizeFee) +
         (Number.isNaN(pricing.inopFee) ? 0 : pricing.inopFee) +
         (Number.isNaN(pricing.sizeFeeByDistance) ? 0 : pricing.sizeFeeByDistance) +
         (Number.isNaN(pricing.depositFeeByDistance) ? 0 : pricing.depositFeeByDistance) +
         (Number.isNaN(pricing.enclosedFee) ? 0 : pricing.enclosedFee);
    },
    calcTotalPrice(pricing) {
      if (pricing.totalPrice) return pricing.totalPrice;

      const {
        basePrice = 0,
        carrierPay = 0,
        sizeFee = 0,
        inopFee = 0,
        enclosedFee = 0,
        deposit = 0,
        sizeFeeByDistance = 0,
        depositFeeByDistance = 0
      } = pricing;

      const total = !carrierPay ? basePrice
        + sizeFee + inopFee + enclosedFee + deposit
        + sizeFeeByDistance + depositFeeByDistance : deposit + carrierPay;

      const fullPay = this.fullPayEnabled ? Math.floor(total * 0.05) : 0;

      this.value.totalPrice = total;
      this.value.fullPay = fullPay;
      this.validation.totalPrice.$model = total;
      this.delayTouch(this.validation.totalPrice, this.$options.touchMap);

      return total;
    },
    setPricesByRunAutoQuote(pricing) {
      const {
        basePrice = 0,
        sizeFee = 0,
        inopFee = 0,
        enclosedFee = 0,
        deposit = 0,
        sizeFeeByDistance = 0,
        depositFeeByDistance = 0
      } = pricing;

      const carrierPay = basePrice
        + sizeFee + inopFee + enclosedFee
        + sizeFeeByDistance + depositFeeByDistance;

      const total = deposit + carrierPay;

      const fullPay = this.fullPayEnabled ? Math.floor(total * 0.05) : 0;
      const totalPrice = total + fullPay;

      const newValue = { ...this.value };
      newValue.carrierPay = carrierPay;
      newValue.totalPrice = totalPrice;
      newValue.fullPay = fullPay;

      this.$emit('input', newValue);
      this.validation.totalPrice.$model = totalPrice;
      this.delayTouch(this.validation.totalPrice, this.$options.touchMap);

      this.calculateLinked(newValue);
    },
    handleChange(value) {
      const { name, model } = value;
      const newValue = { ...this.value, [name]: parseInt(model, 10) };

      if (name === 'deposit') {
        newValue.carrierPay = this.value.totalPrice - model;
      } else if (name === 'carrierPay') {
        newValue.deposit = this.value.totalPrice - model;
      } else { // right side
        const oldCarrierPay = this.calculateCarrierPayByFee();
        const newCarrierPay = oldCarrierPay +
          (Number.isNaN(model) ? 0 : Number(model)) -
          (Number.isNaN(this.value[name]) ? 0 : this.value[name]);

        newValue.carrierPay = newCarrierPay;
        newValue.deposit = this.value.totalPrice - newCarrierPay;
        newValue.totalPrice = newValue.carrierPay + newValue.deposit;
        newValue.fullPay = this.fullPayEnabled ? Math.floor(newValue.totalPrice * 0.05) : 0;
      }
      this.calculateLinked(newValue);

      this.$emit('input', newValue);
    },
    handleTotalPriceChange(value) {
      const newTotalPrice = Number.isNaN(parseInt(value, 10)) ? 0 : parseInt(value, 10);
      const newValue = { ...this.value };
      newValue.carrierPay = newTotalPrice - this.value.deposit;
      newValue.totalPrice = newTotalPrice;
      newValue.fullPay = this.fullPayEnabled ? Math.floor(newTotalPrice * 0.05) : 0;

      this.$emit('input', newValue);
      this.validation.totalPrice.$model = newTotalPrice;
      this.delayTouch(this.validation.totalPrice, this.$options.touchMap);

      this.calculateLinked(newValue);
    },
    handleBatchUpdate() {
      if (this.action === 'view') {
        this.$emit('update');
      }
    },
    handleFullPay(fullPayEnabled) {
      const newValue = { ...this.value };
      newValue.fullPay = fullPayEnabled ? Math.floor(newValue.totalPrice * 0.05) : 0;

      this.$emit('input', newValue);
    }
  }
};
</script>
<style lang="scss">
.input-highlighted-1 .q-field__prefix {
  color: var(--brand-3-color);
}
.input-highlighted-2 .q-field__prefix {
  color: var(--q-color-secondary);
}
.center-content {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
